module.exports = __webpack_public_path__ + "media/ocean_view.14c3c4f0.jpg";